import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { I18nVersionService } from './i18n-version.service';

export class VersionedTranslateLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly i18nVersionService: I18nVersionService,
  ) {}

  public getTranslation(language: string): Observable<Record<string, unknown>> {
    const version = this.i18nVersionService.getVersionForLanguage(language);
    const translationUrl = `./assets/i18n/${language}.json?v=${encodeURIComponent(version)}`;

    return this.http.get<Record<string, unknown>>(translationUrl);
  }
}
